import { render, staticRenderFns } from "./RecommenderTitleCard.vue?vue&type=template&id=fb66bad8&scoped=true"
import script from "./RecommenderTitleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommenderTitleCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecommenderTitleCard.vue?vue&type=style&index=0&id=fb66bad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb66bad8",
  null
  
)

export default component.exports